<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form >
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search Concern Type  Here..."
          class="w-full border p-2 rounded-md outline-none"
          
          placeholder="Search User" matInput (input)="applyFilter($event)"
        />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
        
         (change)="filterByStatus($event)"
        >

        
        <option value="">All</option>
        <option value="Read">Read</option>
        <option value="Unread">Unread</option>
        </select>
      </div>
     
    
    </div>
  </form>
  <div class="bg-white rounded-2xl shadow-md p-4">
  
  <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Title </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.title}} </mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.date | date}} </mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
    </ng-container>
  
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
  </mat-table>
    <app-empty-data
      *ngIf="dataSource.data.length < 1"
      class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'"
      [message]="'No data available'"
    ></app-empty-data>
  <mat-paginator [length]="dataSource.data.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]">
  </mat-paginator>
  </div>

  </div>
  
